<template>
    <div :id="id" class="forgot-pass lottie-animation__forgot-pass" />
</template>

<script>
import lottie from 'lottie-web';

export default {
    name: "GinnyForgotPass",
    props: {
        id: {
            type: String,
            default: 'forgot-pass'
        }
    },
    mounted() {
        console.log('loading animation');
        lottie.loadAnimation({
            container: document.getElementById(this.id),  // the dom element that will contain the animation
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: "/ginny-forgot-pass.json",
            assetsPath: "../assets/animations"
        });
    }
}
</script>

<style scoped lang="scss">
.lottie-animation__forgot-pass {
    svg {
        width: 150%!important;
    }
}
</style>
